import { useMyTranslations } from '@hooks/useMyTranslations';
import { MyFC } from '@/types/common';
import NoResIcon from '@icons/no_results_icon.svg?component';
import { noResultsTranslations } from './translations';
import { NoResultsTransFields } from './types';

export const NoResults: MyFC = ({ children }) => {
  const { t } = useMyTranslations<NoResultsTransFields>([noResultsTranslations.name]);

  return (
    <div className="flex flex-col justify-center items-center gap-y-[12px] h-full">
      <div className="flex-centred bg-container-bg w-[96px] h-[96px] rounded-full">
        <NoResIcon width={48} height={48} />
      </div>
      <p className="page-title-text !leading-[24px]">{t('Have no Results')}</p>
      {children}
    </div>
  );
};
